/**
 * 万圣节活动横幅
 * 单独处理展开按钮，避免点击按钮时触发横幅链接的新标签页跳转。
 */
class HalloweenPromoBanner {
  constructor(element) {
    this.element = element;
    this.toggles = Array.from(element.querySelectorAll('[data-halloween-promo-toggle]'));
    this.details = element.querySelector('[data-halloween-promo-details]');
    this.icon = element.querySelector('[data-halloween-promo-icon]');
    this.hideDetailsTimeout = null;

    if (!this.toggles.length || !this.details || !this.icon) return;

    this.handleToggle = this.handleToggle.bind(this);
    this.toggles.forEach((toggle) => toggle.addEventListener('click', this.handleToggle));
  }

  /** 切换活动说明，并同步辅助技术状态与箭头方向。 */
  handleToggle(event) {
    event.preventDefault();
    event.stopPropagation();

    const isExpanded = this.toggles[0].getAttribute('aria-expanded') === 'true';
    const nextExpanded = !isExpanded;

    window.clearTimeout(this.hideDetailsTimeout);
    this.toggles.forEach((toggle) => {
      toggle.setAttribute('aria-expanded', String(nextExpanded));
      toggle.setAttribute('aria-label', nextExpanded ? 'Hide Halloween offer details' : 'Show Halloween offer details');
    });

    if (nextExpanded) {
      this.details.hidden = false;
      window.requestAnimationFrame(() => this.details.classList.add('is-expanded'));
      return;
    }

    this.details.classList.remove('is-expanded');
    this.hideDetailsTimeout = window.setTimeout(() => {
      this.details.hidden = true;
    }, 320);
  }
}

const initializeHalloweenPromoBanners = (scope = document) => {
  const banners = [];

  if (scope.matches?.('[data-halloween-promo-banner]')) banners.push(scope);
  scope.querySelectorAll?.('[data-halloween-promo-banner]').forEach((banner) => banners.push(banner));

  banners.forEach((banner) => {
    if (!banner.dataset.halloweenPromoInitialized) {
      banner.dataset.halloweenPromoInitialized = 'true';
      new HalloweenPromoBanner(banner);
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initializeHalloweenPromoBanners(), { once: true });
} else {
  initializeHalloweenPromoBanners();
}

document.addEventListener('shopify:section:load', (event) => initializeHalloweenPromoBanners(event.target));
